import React from 'react';
import './HardwareServices.css';
import { 
  FaDesktop, 
  FaKeyboard, 
  FaServer, 
  FaNetworkWired, 
  FaShieldAlt, 
  FaTools, 
  FaArrowRight, 
  FaCheck, 
  FaHdd, 
  FaWrench, 
  FaCertificate 
} from 'react-icons/fa';
import PrinterSoftware from '../PrinterSoftware/PrinterSoftware';

const HardwareServices = () => {
  const services = [
    {
      title: "Desktops & Laptops",
      icon: <FaDesktop />,
      image: "images/71QtoB1MJIL-removebg-preview.png",
      description: "High-performance office workstations and commercial notebooks customized for employee productivity and scaling.",
      features: [
        "Custom Workstation Builds",
        "RAM & High-Speed SSD Upgrades",
        "Thermal Repasting & Cleanups",
        "Complete OS Deployments"
      ]
    },
    {
      title: "Premium Peripherals",
      icon: <FaKeyboard />,
      image: "images/05-500x500.webp",
      description: "High-precision input accessories, mechanical keyboards, ergonomic monitors, and barcode scanners for retail.",
      features: [
        "4K Ergonomic Office Monitors",
        "Heavy-Duty Mechanical Keys",
        "Commercial Barcode Scanners",
        "Interactive Display Mounts"
      ]
    },
    {
      title: "Enterprise Servers",
      icon: <FaServer />,
      image: "images/servers.jpg",
      description: "Secure, high-availability physical rackmount servers, active database structures, and redundancy configurations.",
      features: [
        "Redundant Server Clusters",
        "High-Volume SQL Server Setup",
        "Automated Cloud Backup Sync",
        "Proactive Hardware Monitoring"
      ]
    },
    {
      title: "Network Infrastructure",
      icon: <FaNetworkWired />,
      image: "images/ExitLag-Internet-Network-How-It-Works-and-the-Key-Components.webp",
      description: "Structured Cat6 cabling loops, industrial router load balancing, enterprise firewalls, and secure remote VPNs.",
      features: [
        "Structured Ethernet Cabling",
        "Multi-Wan Router Load Balancers",
        "Secure remote VPN tunnels",
        "Proactive Wi-Fi Heatmaps"
      ]
    },
    {
      title: "Hardware Security Setups",
      icon: <FaShieldAlt />,
      image: "/images/WhatsApp_Image_2024-10-21_at_4.47.15_PM-removebg-preview.png",
      description: "Next-generation Fortinet, Cyberoam, and SonicWall hardware firewall installations for multi-branch environments.",
      features: [
        "FortiGate Hardware Firewalls",
        "Strict VLAN Access Boundaries",
        "IPS Intrusion Prevention Loop",
        "Active DMZ Architecture"
      ]
    },
    {
      title: "Deployment & Installation",
      icon: <FaTools />,
      image: "images/photo_technician-repairing-computer.webp",
      description: "Professional onsite IT installation services, absolute cable management, and pro hardware troubleshooting.",
      features: [
        "Absolute Cable Management",
        "Clean OS & Driver Configurations",
        "Hardware Performance Auditing",
        "Onsite Fast Repairs Support"
      ]
    }
  ];

  return (
    <div className="hardware-page-wrapper">
      {/* ── Cinematic Full-Width Header Banner ── */}
      <header className="hardware-header" style={{ backgroundImage: 'linear-gradient(rgba(15, 23, 42, 0.45), rgba(15, 23, 42, 0.65)), url("/hardware/hardware.png")' }}>
        <div className="hardware-header-overlay-content">
          <h1>Hardware Sales & Service</h1>
        </div>
      </header>

      <div className="hardware-root">
        {/* ── Hardware Intro & Live Metrics Section Below Cover ── */}
        <section className="hardware-intro-section">
          <div className="hardware-hero-inner">
            <div className="hardware-hero-content">
              <span className="hero-tagline">
                <FaServer className="tagline-icon" /> ENTERPRISE IT INFRASTRUCTURE
              </span>
              <h2 className="hero-title-below">
                High-Availability <br />
                <span className="gradient-text">Hardware Solutions</span>
              </h2>
              <p className="hero-desc-below">
                iMatrix Technologies provisions, designs, and maintains state-of-the-art office setups, secure corporate networks, high-performance database servers, and modern business print fleets. Empower your workers with reliable computing power.
              </p>
              <div className="hero-ctas">
                <a href="#services" className="btn-primary">
                  View Infrastructure Services <FaArrowRight className="btn-arrow" />
                </a>
                <a href="#printers" className="btn-secondary">
                  Explore Printing
                </a>
              </div>
            </div>

            <div className="hardware-hero-visual">
              <div className="hero-status-card">
                <div className="status-card-header">
                  <span className="pulse-indicator-hw"></span>
                  <span className="status-title-hw">IT Infrastructure: OPERATIONAL</span>
                </div>
                
                <div className="status-metrics-list">
                  <div className="metric-row">
                    <div className="metric-icon-box"><FaDesktop /></div>
                    <div className="metric-info-box">
                      <span className="metric-value-hw">250+</span>
                      <span className="metric-label-hw">Workstations Configured & Setup</span>
                    </div>
                  </div>

                  <div className="metric-row">
                    <div className="metric-icon-box"><FaServer /></div>
                    <div className="metric-info-box">
                      <span className="metric-value-hw">99.99%</span>
                      <span className="metric-label-hw">Enterprise Server Uptime Maintained</span>
                    </div>
                  </div>

                  <div className="metric-row">
                    <div className="metric-icon-box"><FaNetworkWired /></div>
                    <div className="metric-info-box">
                      <span className="metric-value-hw">24/7</span>
                      <span className="metric-label-hw">Proactive Threat & Network Monitoring</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      {/* ── 2. ADVANTAGES ASSURANCES ── */}
      <section className="hardware-assurances-banner">
        <div className="container-wide assurance-grid-hardware">
          <div className="assurance-item-hw">
            <div className="assurance-icon-box-hw">
              <FaCertificate />
            </div>
            <div className="assurance-text-hw">
              <h4>OEM Certified Partners</h4>
              <p>Direct brand vendor partnerships, assuring genuine retail boxes and authentic guarantees.</p>
            </div>
          </div>

          <div className="assurance-item-hw">
            <div className="assurance-icon-box-hw">
              <FaWrench />
            </div>
            <div className="assurance-text-hw">
              <h4>Certified IT Technicians</h4>
              <p>Network wiremen and system engineers for tidy installations and rapid problem-solving.</p>
            </div>
          </div>

          <div className="assurance-item-hw">
            <div className="assurance-icon-box-hw">
              <FaHdd />
            </div>
            <div className="assurance-text-hw">
              <h4>Standby Buffers</h4>
              <p>Immediate failover hardware buffers and quick replacements to keep business moving.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── 3. SERVICES SECTION (3 columns desktop, full width) ── */}
      <section id="services" className="hardware-services-section">
        <div className="container-wide">
          <div className="section-header-centered">
            <span className="sub-title">CORE PROVISIONING</span>
            <h2 className="section-title">Industrial IT Deployments</h2>
            <p className="section-desc">
              We design, install, and manage corporate workstation networks, structured cable lines, and database servers.
            </p>
          </div>

          <div className="hardware-services-grid">
            {services.map((service, index) => (
              <div className="hardware-card-modern" key={index}>
                <div className="card-top-icon">{service.icon}</div>
                
                <div className="hardware-img-container">
                  <img src={service.image} alt={service.title} />
                </div>
                
                <div className="hardware-card-body">
                  <h3 className="card-title-hw">{service.title}</h3>
                  <p className="card-desc-hw">{service.description}</p>
                  
                  <div className="features-divider-hw"></div>
                  
                  <ul className="card-features-hw">
                    {service.features.map((feat, i) => (
                      <li key={i}>
                        <FaCheck className="tick-icon-hw" />
                        <span>{feat}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <a href="/contact" className="hardware-card-cta">
                    Request Integration <FaArrowRight className="cta-arrow-hw" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 4. INTEGRATED PRINTER SHOWCASE ── */}
      <section id="printers" className="printer-integration-section">
        <div className="container-wide">
          <PrinterSoftware />
        </div>
      </section>
    </div>
    </div>
  );
};

export default HardwareServices;
